import { useEffect, useReducer } from "react";
import Api from "./api.js";

const BASE_URL = "/api/v1";
const apiService = new Api();

const initialState = {
  isIdle: true,
  isLoading: false,
  response: null,
  error: null,
};

function requestReducer(defaultResponse) {
  return (state, action) => {
    const updatedState = { ...state };

    switch (action.type) {
      case "FETCHING":
        updatedState.isLoading = true;
        updatedState.response = defaultResponse;
        updatedState.error = null;
        break;

      case "SUCESS":
        updatedState.isLoading = false;
        updatedState.response = action.data;
        break;

      case "ERROR":
        updatedState.isLoading = false;
        updatedState.error = action.error;
        break;

      default:
        break;
    }

    return updatedState;
  }
}

export default function useApiService({ url, method = "get", payload, onMount, onSuccess, defaultResponse }) {
  const [state, dispatch] = useReducer(requestReducer(defaultResponse), {...initialState, response: defaultResponse});

  function sendRequest(requestPayload=payload) {
    dispatch({ type: "FETCHING" });
    apiService[method](`${BASE_URL}${url}`, requestPayload)
      .then(({ data }) => {
        dispatch({ type: "SUCESS", data });
        onSuccess && onSuccess(data);
      })
      .catch((error) => dispatch({ type: "ERROR", error }));
  }

  useEffect(() => {
    onMount && sendRequest(payload);
  }, []);

  return [state, sendRequest];
}



// WEBPACK FOOTER //
// ./src/services/useApiService.js